import { Component, Input, Signal, computed } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { ChartMarkers } from '@scenario/enums/chart/chart-markers.enum';
import { dispatch, select } from '@store/injectables';
import {
  AppState,
  saveSourceChartMarker,
  saveZoneChartMarker,
  selectAppMode,
  selectChartMarkersConfiguration, selectSelectedChartMarkers,
} from '@store/scenario/app/app-slice';
import { capitalize } from '@utils/capitalize';
import { Filters } from '@scenario/enums/filters.enum';
import { selectUserPreferencesViewModel } from '@store/scenario/user-preferences/user-preferences-slice';

@Component({
    selector: 'app-chart-markers',
    imports: [
        MatIconButton,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuItem
    ],
    templateUrl: './chart-markers.component.html',
    styleUrl: './chart-markers.component.scss'
})
export class ChartMarkersComponent {
  dispatch = dispatch();
  selectedChartMarkers = select(selectSelectedChartMarkers);
  userPreferences = select(selectUserPreferencesViewModel);
  advancedMode = computed(() => this.userPreferences().userPreferences.advanced);
  chartMarkers = ChartMarkers;
  protected readonly capitalize = capitalize;

  @Input() targetedFieldName : string;
  @Input() targetedFieldValues: string;

  chartMarkersConfiguration = select(selectChartMarkersConfiguration);
  app: Signal<AppState> = select(selectAppMode);

  public options: { path: string | null; chartMarker: ChartMarkers }[] = Object.values(ChartMarkers)
    .map((chartMarker: ChartMarkers) => ({
      path: `assets/images/markers/${chartMarker.toLowerCase()}_option.svg`,
      chartMarker: chartMarker
    }));

  saveChartMarker(chartMarkerToSave: ChartMarkers) {
    if(this.targetedFieldName === Filters.REGION.toLowerCase()) {
      this.dispatch(saveZoneChartMarker(chartMarkerToSave));
    }
    if(this.targetedFieldName === Filters.SOURCE.toLowerCase()) {
      this.dispatch(saveSourceChartMarker(chartMarkerToSave));
    }
  }

  protected readonly ChartMarkers = ChartMarkers;
}
